import { render, staticRenderFns } from "./MarketplacePaymentModal.vue?vue&type=template&id=ecdd51e8&scoped=true"
import script from "./MarketplacePaymentModal.vue?vue&type=script&lang=ts"
export * from "./MarketplacePaymentModal.vue?vue&type=script&lang=ts"
import style0 from "./MarketplacePaymentModal.vue?vue&type=style&index=0&id=ecdd51e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdd51e8",
  null
  
)

export default component.exports